import axios from '@/axios/axios'

export default {
    namespaced: true,
    state:{
        searchText : "",
        perPage: 10,
        currentPage: 1,
        totalCnt: 0,
        sortBy: 'IDX',
        sortDesc: false,
        fields: [],
        items: [],
        selected: [],
        routerName : "",
        url : "",
        getListURL : ""
    },
    mutations:{
        setInitBoard: (state, payload) => {
            if(payload.searchText){
                state.searchText = payload.searchText;
            }
            
            if(payload.perPage){
                state.perPage = payload.perPage;
            }

            if(payload.currentPage){
                state.currentPage = payload.currentPage;
            }

            if(payload.totalCnt){
                state.totalCnt = payload.totalCnt;
            } else {
                state.totalCnt = 0;
            }

            if(payload.sortBy){
                state.sortBy = payload.sortBy;
            }

            if(payload.sortDesc){
                state.sortDesc = payload.sortDesc;
            }

            if(payload.fields){
                state.fields = payload.fields;
            }

            if(payload.items){
                state.items = payload.items;
            }

            if(payload.totalCnt){
                state.totalCnt = payload.totalCnt;
            }

            if(payload.routerName){
                state.routerName = payload.routerName;
            }

            if(payload.url){
                state.url = payload.url;
            }
            
            if(payload.getListURL){
                state.getListURL = payload.getListURL;
            }
        }
    },
    actions:{
        setBoardSetting({ commit }, payload){
            commit("setInitBoard", payload);
        },
        getBoardList({ state, commit }, payload){
            let searchText = payload.searchText;
            if(!searchText){
                searchText = "";
            }

            return axios
            .post(state.getListURL, {
                currentPage: payload.currentPage,
                perPage: payload.perPage,
                sortBy: payload.sortBy,
                sortDesc: payload.sortDesc,
                searchText : searchText
            })
            .then(response => {
                
                payload.items = response.data.items;
                payload.totalCnt = response.data.totalCnt;
                
                commit("setInitBoard", payload);

                return Promise.resolve(response);
            })
            .catch(error => {
                return Promise.reject(error);
            })
        },
    }
}